import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'projects/frontend/src/app/shared/services/auth/auth.service';
import { StoreService } from 'projects/frontend/src/app/shared/services/store.service';
import { ModalService } from '../../../services/modal.service';

@Component({
    selector: 'footer-area-notelegali',
    templateUrl: './notelegali.component.html',
    styleUrls: ['./notelegali.component.scss'],
    standalone: false
})
export class FooterAreaNotelegaliComponent implements OnInit {

  constructor(
    public translateService: TranslateService,
    public storeService: StoreService,
    public authService: AuthService,
    public modalService: ModalService
  ) {}

  ngOnInit(): void { }

  openPrivacy() {
    this.modalService.hideModal('legal-popup');
    this.modalService.showModal('privacy-popup');
  }
}
